import { useEffect, useRef } from "react";
import { gsap } from "@/lib/gsap";
import { useT } from "@/i18n";
import useReveal from "@/hooks/useReveal";

const CLIENTS = [
  "NusaPost", "Karya Mandiri", "TerraLogis", "Kopi Suara", "Bumi Sawit",
  "Sembada Bank", "Asana Health", "Nurani Foundation", "Lokananta Studio",
  "Citra Niaga", "Pinisi Logistics", "Wastra Apparel",
];

export default function ClientLogos() {
  const ref = useRef(null);
  const { t } = useT();

  useReveal(ref, () => {
    const ctx = gsap.context(() => {
      gsap.from("[data-anim='cl-title']", { opacity: 0, y: 40, duration: 0.95, ease: "power3.out" });
    }, ref);
    return () => ctx.revert();
  });

  const loop = [...CLIENTS, ...CLIENTS];

  return (
    <div
      ref={ref}
      className="relative w-full h-screen overflow-hidden flex flex-col justify-center"
      style={{ background: "var(--paper)" }}
      data-testid="clients-root"
    >
      <div className="px-8 md:px-24 lg:px-40 mb-20">
        <h2 data-anim="cl-title" className="h-section text-[var(--ink)] max-w-[40rem]">
          {t("clients.titleA")} {t("clients.titleHL")} {t("clients.titleB")}
        </h2>
      </div>

      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10" style={{ background: "linear-gradient(90deg, var(--paper), transparent)" }} />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10" style={{ background: "linear-gradient(270deg, var(--paper), transparent)" }} />

        <div className="flex marquee-track" style={{ width: "max-content" }}>
          {loop.map((c, i) => (
            <div key={`${c}-${i}`} className="flex items-center gap-4 px-12 py-3 whitespace-nowrap border-r border-black/10 last:border-r-0">
              <span className="inline-block w-1.5 h-1.5 rounded-sm" style={{ background: "var(--violet)" }} />
              <span className="font-display text-[var(--ink)] text-lg md:text-2xl" style={{ letterSpacing: "-0.02em", fontWeight: 600, opacity: 0.85 }}>
                {c}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
